export default __webpack_public_path__ + "static/build_on_header-1ec1b2e941d463614b3c71381d98cbab.png";